<template>
    <div class="numberchange">
        <van-form @submit="onSubmit" ref="formRef">
            <van-cell-group inset>
                <van-field
                    v-model="params.mobile"
                    type="tel"
                    label="新手机号码"
                    label-width="80rem"
                    placeholder="请输入新手机号码"
                    :rules="[{ required: true, message: '请输入手机号码' }, { validator: validateMobile, message: '手机号格式不正确' }]"
                />
                <van-field
                    :model-value="maskedMobile"
                    label="原手机号码"
                    label-width="80rem"
                    readonly
                />
                <van-field
                    v-model="params.code"
                    center
                    clearable
                    label="验证码"
                    label-width="80rem"
                    placeholder="请输入验证码"
                    :rules="[{ required: true, message: '请输入验证码' }]"
                >
                    <template #button>
                        <span v-if="remainSecond <= 0" class="auth-btn limit" @click="sendCodeAction">获取验证码</span>
                        <span v-else class="auth-btn limit fail">{{ remainSecond }}秒后获取</span>
                    </template>
                </van-field>
            </van-cell-group>
            <div class="confirm">
                <van-button type="primary" block @click="changePhone">确认修改</van-button>
            </div>
        </van-form>
    </div>
</template>

<script setup>
import { ref, computed, reactive } from 'vue'
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { showNotify } from 'vant'

const store = useStore()
const maskedMobile = computed(() => {
    const mobile = store.state.login.userInfo.mobile
    if (!mobile || mobile.length !== 11) return mobile
    return mobile.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
})

const remainSecond = ref(0)
const formRef = ref(null)

const params = reactive({
    mobile: '',
    code: ''
})

let timer = null

const validateMobile = (value) => {
    return /^1[3-9]\d{9}$/.test(value)
}

const sendCodeAction = () => {
    const mobile = store.state.login.userInfo.mobile
    if (!mobile) {
        showNotify({ message: '手机号不存在' })
        return
    }
    http.post('/app-api/member/auth/send-sms-code', { mobile, scene: 2 }).then(res => {
        showNotify({ message: '验证码已发送' })
        remainSecond.value = 60
        timer = setInterval(() => {
            remainSecond.value--
            if (remainSecond.value <= 0) {
                clearInterval(timer)
            }
        }, 1000)
    }).catch(err => {
        showNotify({ message: err })
    })
}

const changePhone = () => {
    if (!validateMobile(params.mobile)) {
        showNotify({ message: '手机号格式不正确' })
        return
    }
    http.put('/app-api/member/user/update-mobile', {
        mobile: params.mobile,
        code: params.code
    }).then(res => {
        showNotify({ message: '修改成功' })
    })
}

const onSubmit = () => {
    changePhone()
}
</script>

<style scoped lang="scss">
.auth-btn {
    width: 80rem;
    height: 30rem;
    border-radius: 5rem;
    color: #0A84FF;
    border: 1px solid #0A84FF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12rem;
    font-weight: 500;
    &.limit {
        width: 80rem;
    }
    &.fail {
        opacity: .7;
        cursor: not-allowed;
        background: #ccc;
        border-color: #ccc;
    }
}
.numberchange {
    background-color: white;
    border-radius: 10rem;
    overflow: hidden;
    padding: 20rem 0;
}
.confirm {
    padding: 30rem 20rem;
    :deep(.van-button) {
        width: 80%; height: 40rem; margin: 0 auto; background-color: #000; color: white; border: none; border-radius: 0;
    }
}

</style>
